import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '@/modules/localizations/translations/types';
import { Text } from '@/modules/ui';

import type { Fields } from '../../../../../../constants';
import type { Secret } from '../../../../../../types';
import { SecretFieldSection } from '../../../../../SecretFieldSection';
import { CopySecretValue } from '../../../CopySecretValue';
import * as felaRules from './CopySection.rules';

export interface CopySectionProps {
    secret: Secret;
    property: Fields;
    mask?: ReactNode;
    headingMessageKey: MessageKey;
    visible?: boolean;
    disabled?: boolean;
}

export const CopySection = ({ secret, property, mask, headingMessageKey, visible, disabled }: CopySectionProps) => {
    if (!visible) return null;

    const displayedText = mask ?? (secret[property as keyof typeof secret] as ReactNode);

    return (
        <SecretFieldSection heading={<FormattedMessage id={headingMessageKey} />} customLabelStyle={felaRules.propertyLabel}>
            <Text variant='ParagraphNormalRegular' customStyle={mask ? felaRules.cryptedCharacters : felaRules.propertyText}>
                {displayedText}
            </Text>
            <CopySecretValue id={secret.id} property={property} disabled={disabled} />
        </SecretFieldSection>
    );
};
